import _reactJsxDevRuntimeProductionMin from "./cjs/react-jsx-dev-runtime.production.min.js";
export { _reactJsxDevRuntimeProductionMin as default };
export const Fragment = _reactJsxDevRuntimeProductionMin.Fragment,
  jsxDEV = _reactJsxDevRuntimeProductionMin.jsxDEV;